<body class="horizontal-layout horizontal-menu 2-columns">
  <!-- BEGIN: Header-->
  <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-static-top navbar-dark navbar-border navbar-brand-center">
      <div class="navbar-wrapper">
          <div class="navbar-container container center-layout">
              <div class="collapse navbar-collapse" id="navbar-mobile">
                  <ul class="nav navbar-nav mr-auto float-left">
                      <li class="nav-item">
                          <a class="" href="javascript:void(0)">
                              <img class="brand-logo logo" src="/assets/images/logo-light.svg">
                          </a>
                      </li>
                  </ul>
                  <ul class="nav navbar-nav float-right">
                      <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/">
                              <!-- <i class="feather icon-home"></i> -->
                              <span>Home</span>
                          </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/about-us/">
                              <!-- <i class="feather icon-globe"></i> -->
                              <span>About Us</span>
                          </a>
                      </li>
                      <!-- <i class="feather icon-globe"></i> -->
                      <!-- <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/our-story/">
                              <span>Our Story</span>
                          </a>
                      </li> -->
                      <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/levels/">
                              <!-- <i class="feather icon-book-open"></i> -->
                              <span>Levels</span>
                          </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/pricing/">
                              <!-- <i class="feather icon-credit-card"></i> -->
                              <span>Pricing</span>
                          </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/levels/">
                              <!-- <i class="feather icon-book-open"></i> -->
                              <span>Practokit</span>
                          </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="http://mathecad.com/contact-us/">
                              <!-- <i class="feather icon-phone"></i> -->
                              <span>Contact Us</span>
                          </a>
                      </li>
                      <li class="nav-item ml-1">
                          <a class="nav-link nav-link-action" href="javascript:void(0)" [routerLink]="['/signin']" >
                              <i class="feather icon-user"></i>
                              <span>Signin to your Account</span>
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
  </nav>
  <!-- END: Header-->

  <div class="app-content content">
      <div class="content-wrapper">
          <div class="content-header row">
              <div class="content-header-left col-12 my-2">
                  <h3 class="content-header-title text-center mb-0">
                      <span>SignUp</span>
                      <br>
                      <small *ngIf = "step1" style="font-size: 60%;">Select Role from below</small>
                      <small *ngIf = "step2" style="font-size: 60%;">Fill up the below fields to create a new account</small>
                  </h3>
              </div>
          </div>

          <div class="content-body">
              <section class="row all-contacts">
                  <div class="col-12">
                      <!-- Step 1 -->
                      <div *ngIf = "step1">
                          <div class="icons-tab-steps wizard-circle wizard clearfix">
                              <div class="steps clearfix mb-2">
                                  <ul role="tablist">
                                      <li role="tab" class="first current">
                                          <a href="javascript:void(0)">
                                              <span class="current-info audible">current step: </span>
                                              <span class="step"><i class="step-icon feather icon-user"></i></span>
                                              Select Role
                                          </a>
                                      </li>
                                      <li role="tab" class="disabled">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-file"></i></span>
                                              Write About Yourself
                                          </a>
                                      </li>
                                      <!-- <li role="tab" class="disabled" *ngIf="role == 'Student'">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-list"></i></span>
                                              Select Package
                                          </a>
                                      </li> -->
                                      <li role="tab" class="disabled last">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon  feather icon-cpu"></i></span>
                                              Confirmation
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                          <section class="my-3">
                              <fieldset>
                                  <div class="row">
                                      <div class="col-md-8 offset-md-2">
                                          <div class="row">
                                              <div class="col-md-6 col-12">
                                                  <div class="card card-link mb-0" [class.active]="role == 'Student'">
                                                      <div class="card-content py-2" (click)="role = 'Student'">
                                                          <div class="card-body text-center">
                                                              <img src="/assets/images/icon-student.png">
                                                              <h5 class="mt-2 mb-0">Student</h5>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-md-6 col-12">
                                                  <div class="card card-link mb-0" [class.active]="role == 'Teacher'">
                                                      <div class="card-content py-2" (click)="role = 'Teacher'">
                                                          <div class="card-body text-center">
                                                              <img src="/assets/images/icon-teacher.png">
                                                              <h5 class="mt-2 mb-0">Teacher</h5>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row justify-content-center mt-5">
                                      <button type="button" class="btn btn-primary" (click)="ActivateStep2()">NEXT</button>
                                  </div>
                              </fieldset>
                          </section>
                      </div>
                      <!-- Step 2 -->
                      <div *ngIf = "step2">
                          <div class="icons-tab-steps wizard-circle wizard clearfix">
                              <div class="steps clearfix mb-2">
                                  <ul role="tablist">
                                      <li role="tab" class="first done">
                                          <a href="javascript:void(0)">
                                              <span class="current-info audible">current step: </span>
                                              <span class="step"><i class="step-icon feather icon-user"></i></span>
                                              Select Role
                                          </a>
                                      </li>
                                      <li role="tab" class="current">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-file"></i></span>
                                              Write About Yourself
                                          </a>
                                      </li>
                                      <!-- <li role="tab" class="disabled" *ngIf="role == 'Student'">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-list"></i></span>
                                              Select Package
                                          </a>
                                      </li> -->
                                      <li role="tab" class="disabled last">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon  feather icon-cpu"></i></span>
                                              Confirmation
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                          <section class="my-3">
                              <div class="card">
                                  <div class="card-content">
                                      <div class="card-body">
                                          <!-- Personal Information -->
                                          <fieldset>
                                              <h5 class="heading font-weight-bold mt-0">Personal Information</h5>
                                              <div class="row">
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="firstName2">First Name </label>
                                                          <span class="steric">*</span>
                                                          <input type="text" class="form-control" id="firstName2" [(ngModel)]="firstName" #FirstName="ngModel" required maxlength="45" placeholder="First Name">
                                                          <span class="text-danger" *ngIf="FirstName.invalid && FirstName.touched">
                                                              * First Name is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="lastName2">Last Name </label>
                                                          <span class="steric">*</span>
                                                          <input type="text" class="form-control" id="lastName2" [(ngModel)]="lastName"
                                                          #LastName="ngModel" required maxlength="45" placeholder="Last Name">
                                                          <span class="text-danger" *ngIf="LastName.invalid && LastName.touched">
                                                              * Last Name is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="emailAddress3">Email Address </label>
                                                          <span class="steric">*</span>
                                                          <input type="email" class="form-control" id="emailAddress3" [(ngModel)]="email"
                                                          (keyup)="checkEmail()" maxlength="255" placeholder="Email Address"
                                                          pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" #Email="ngModel" required>
                                                          <span *ngIf="(Email.errors && Email.errors['pattern'] || Email.invalid) && Email.touched"
                                                              class="text-danger">
                                                              * Field Data must be a valid Email address.
                                                          </span>
                                                          <span *ngIf="resendEmail">
                                                              * This email is already registered and pending verification.
                                                              <a href="javascript:void(0)" (click)="ResendEmail()">Resend Email</a>
                                                          </span>
                                                          <span *ngIf="emailMessage" class="text-danger">
                                                              * {{emailMessage}}
                                                          </span>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="row">
                                                  <div class="col-md-4">
                                                      <form [formGroup]="form">
                                                          <div class="form-group">
                                                              <label for="phoneNumber2">Mobile Number ( xxxx-xxxxxxx )</label>
                                                              <span class="steric">*</span>
                                                              <input appPhoneMask type="text" class="form-control" id="phoneNumber2" required maxlength="12" formControlName="phone" placeholder="Mobile Number">
                                                              <!-- <span class="text-danger" *ngIf="(Mobile.errors && Mobile.errors.pattern || Mobile.invalid) && Mobile.touched">
                                                                  * Field data must be a valid Mobile Number
                                                              </span> -->
                                                          </div>
                                                      </form>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="date2">Date of Birth </label>
                                                          <span class="steric">*</span>
                                                              <div class="input-group">
                                                              <input class="form-control" placeholder="Select Date of Birth" name="dp" readonly
                                                                  [(ngModel)]="dob" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}"
                                                                  [maxDate]="currentDate" #d="ngbDatepicker">
                                                              <div class="input-group-append">
                                                                  <button class="btn btn-outline-secondary calendar d-flex align-items-center"
                                                                      (click)="d.toggle()" type="button">
                                                                      <i class="feather icon-calendar"></i>
                                                                  </button>
                                                              </div>
                                                          </div>

                                                          <!-- <span class="text-danger" *ngIf="dob.invalid && dob.touched">
                                                              * Date of Birth is required
                                                          </span> -->
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="referrence">From where did you hear about us?</label>
                                                          <span class="steric">*</span>
                                                          <select class="form-control" id="referrence" required
                                                              name="location"  [(ngModel)]="heardFrom" #HeardFrom="ngModel">
                                                              <option value="">Select option</option>
                                                              <option value="Friends or Family">Friends or Family</option>
                                                              <option value="Website">Website</option>
                                                              <option value="Facebook">Facebook</option>
                                                              <option value="Instagram">Instagram</option>
                                                              <option value="LinkedIn">LinkedIn</option>
                                                              <option value="Twitter">Twitter</option>
                                                          </select>
                                                          <span class="text-danger" *ngIf="HeardFrom.invalid && HeardFrom.touched">
                                                              * This feild is required
                                                          </span>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="row">
                                                  <div class="col-md-8">
                                                      <div class="form-group">
                                                          <label for="address">Address </label>
                                                          <span class="steric">*</span>
                                                          <input type="text" class="form-control" id="address" [(ngModel)]="address" required #Address="ngModel" placeholder="Address">
                                                          <span class="text-danger" *ngIf="Address.invalid && Address.touched">
                                                              * Address is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="location2">City</label>
                                                          <span class="steric">*</span>
                                                          <ng-autocomplete
                                                                  class="form-control"
                                                                  [data]="data"
                                                                  placeHolder="Select City"
                                                                  [searchKeyword]="keyword"
                                                                  (selected)='city = $event.id'
                                                                  [itemTemplate]="itemTemplate"
                                                                  [notFoundTemplate]="notFoundTemplate">
                                                          </ng-autocomplete>

                                                          <ng-template #itemTemplate let-item>
                                                              <a [innerHTML]="item.name"></a>
                                                          </ng-template>

                                                          <ng-template #notFoundTemplate let-notFound>
                                                              <div [innerHTML]="notFound"></div>
                                                          </ng-template>
                                                      </div>
                                                  </div>
                                              </div>
                                          </fieldset>
                                          <!-- Education Information     -->
                                          <fieldset>
                                              <h5 class="heading font-weight-bold">Education Information</h5>
                                              <!-- Student Education Fields -->
                                              <div class="row" *ngIf = "role == 'Student'">
                                                  <div class="col-md-8">
                                                      <div class="row">
                                                          <div class="col-md-12">
                                                              <div class="form-group">
                                                                  <label for="school">School Name</label>
                                                                  <span class="steric">*</span>
                                                                  <input type="text" class="form-control" id="school" [(ngModel)]="school"
                                                                      required #School="ngModel" maxlength="255" placeholder="School Name">
                                                                  <span class="text-danger" *ngIf="School.invalid && School.touched">
                                                                      * School Name is required
                                                                  </span>
                                                              </div>
                                                          </div>
                                                          <!-- <div class="col-md-4">
                                                              <div class="form-group">
                                                                  <label for="grade">Class / Grade</label>
                                                                  <span class="steric">*</span>
                                                                  <input type="text" class="form-control" id="grade" [(ngModel)]="grade"
                                                                      required #Grade="ngModel" maxlength="45" placeholder="Class / Grade">
                                                                  <span class="text-danger" *ngIf="Grade.invalid && Grade.touched">
                                                                      * Grade/Class is required
                                                                  </span>
                                                              </div>
                                                          </div> -->
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <!-- <label for="guardian-name">Class you want to take </label> -->
                                                          <label for="grade">Class / Grade</label>
                                                          <span class="steric">*</span>
                                                          <select class="form-control" name="course" id="select-course"
                                                          (change)="addCourse($event)" #Course>
                                                              <option selected disabled value="">Select a Class</option>
                                                              <option *ngFor="let course of courses" value="{{course.name}}">{{course.name}}</option>
                                                          </select>
                                                          <!-- <span class="text-danger" *ngIf="Course.invalid && Course.touched">
                                                              * This feild is required
                                                          </span> -->
                                                      </div>
                                                  </div>
                                              </div>
                                              <!-- Teacher Education Fields -->
                                              <div class="row" *ngIf = "role == 'Teacher'">
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="qualification">Education</label>
                                                          <span class="steric">*</span>
                                                          <input type="text" class="form-control" id="qualification" [(ngModel)]="educationName"
                                                              required #EducationName="ngModel" maxlength="45" placeholder="Education">
                                                          <span class="text-danger" *ngIf="EducationName.invalid && EducationName.touched">
                                                              * Education is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="experience">Experience ( in years )</label>
                                                          <span class="steric">*</span>
                                                          <input type="number" class="form-control" id="experience" [(ngModel)]="experience" oninput="validity.valid||(value='');"
                                                              required #Experience="ngModel" maxlength="2" min="0" max="99" placeholder="Experience ( in years )">
                                                          <span class="text-danger" *ngIf="Experience.invalid && Experience.touched">
                                                              * Experience is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="resume">Resume ( PDF / Doc File) </label>
                                                          <span class="steric">*</span>
                                                          <input type="file"  style="overflow: hidden;" class="form-control" id="resume"
                                                              (change)="setResume($event)" accept=".pdf, .doc, .docx">
                                                      </div>
                                                  </div>
                                              </div>
                                          </fieldset>
                                          <!-- Guardian Information     -->
                                          <fieldset *ngIf="role == 'Student'">
                                              <h5 class="heading font-weight-bold">Guardian Information</h5>
                                              <div class="row">
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="guardian-name">Full Name </label>
                                                          <span class="steric">*</span>
                                                          <input type="text" class="form-control" id="guardian-name" [(ngModel)]="guardianName"
                                                              required #GuardianName="ngModel" maxlength="45" placeholder="Guardian's Full Name">
                                                          <span class="text-danger" *ngIf="GuardianName.invalid && GuardianName.touched">
                                                              * Guardian Name is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <div class="form-group">
                                                          <label for="guardian-relation">Relation </label>
                                                          <span class="steric">*</span>
                                                          <input type="text" class="form-control" id="guardian-relation" [(ngModel)]="guardianRelation"
                                                              required #GuardianRelation="ngModel" maxlength="45" placeholder="Relation to Guardian">
                                                          <span class="text-danger" *ngIf="GuardianRelation.invalid && GuardianRelation.touched">
                                                              * Guardian Relation is required
                                                          </span>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4">
                                                      <form [formGroup]="form">
                                                          <div class="form-group">
                                                              <label for="guardian-mobile">Mobile Number ( xxxx-xxxxxxx )</label>
                                                              <span class="steric">*</span>
                                                              <input appPhoneMask type="text" class="form-control" id="guardian-mobile"  formControlName="guardianPhone" required maxlength="12" placeholder="Guardian's Mobile Number">
                                                          </div>
                                                      </form>
                                                  </div>
                                              </div>
                                          </fieldset>
                                          <fieldset>
                                              <div class="row">
                                                  <div class="col-12">
                                                      <div class="d-flex justify-content-between mt-2">
                                                          <button type="button" class="btn btn-secondary" (click)="ActivateStep1()">BACK</button>
                                                          <button type="button" class="btn btn-primary" (click)="veifyData()"
                                                              [disabled]="((Email.errors && Email.errors['pattern'] || Email.invalid) && Email.touched) || signupDisabled" >NEXT</button>
                                                      </div>
                                                  </div>
                                                  </div>
                                          </fieldset>
                                      </div>
                                  </div>
                              </div>
                          </section>
                      </div>
                      <!-- Step 3( Not Working ) -->
                      <div *ngIf = "step3">
                          <div class="icons-tab-steps wizard-circle wizard clearfix">
                              <div class="steps clearfix mb-2">
                                  <ul role="tablist">
                                      <li role="tab" class="first done">
                                          <a href="javascript:void(0)">
                                              <span class="current-info audible">current step: </span>
                                              <span class="step"><i class="step-icon feather icon-user"></i></span>
                                              Select Role
                                          </a>
                                      </li>
                                      <li role="tab" class="done">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-file"></i></span>
                                              Write About Yourself
                                          </a>
                                      </li>
                                      <li role="tab" class="current">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-list"></i></span>
                                              Select Package
                                          </a>
                                      </li>
                                      <li role="tab" class="disabled last">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon  feather icon-cpu"></i></span>
                                              Confirmation
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                          <section class="my-3">
                              <fieldset>
                                  <div class="row">
                                      <div class="col-md-4 col-12" *ngFor="let package of packages">
                                          <div class="card card-link mb-0" [class.active]="packageId == package.id"
                                              (click)="packageId = package.id">
                                              <div class="card-content">
                                                  <div class="card-body text-center">
                                                      <div class="title">
                                                          <h4 class="card-title font-weight-bold">{{package.title}}</h4>
                                                          <h6 class="card-subtitle text-muted">{{package.description}}</h6>
                                                      </div>
                                                      <div class="content">
                                                          <h1 class="price">{{package.price}} <small>RS. </small></h1>
                                                          <h6>Monthly</h6>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </fieldset>
                              <fieldset>
                                  <div class="row justify-content-between px-5 mt-5">
                                      <button type="button" class="btn btn-secondary" (click)="ActivateStep2()">BACK</button>
                                      <button type="button" class="btn btn-primary" (click)="ActivateStep4()"
                                          [disabled]="!packageId">NEXT</button>
                                  </div>
                              </fieldset>
                          </section>
                      </div>
                      <!-- Step 4 -->
                      <div *ngIf="step4">
                          <div class="icons-tab-steps wizard-circle wizard clearfix">
                              <div class="steps clearfix mb-2">
                                  <ul role="tablist">
                                      <li role="tab" class="first done">
                                          <a href="javascript:void(0)">
                                              <span class="current-info audible">current step: </span>
                                              <span class="step"><i class="step-icon feather icon-user"></i></span>
                                              Select Role
                                          </a>
                                      </li>
                                      <li role="tab" class="done">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-file"></i></span>
                                              Write About Yourself
                                          </a>
                                      </li>
                                      <!-- <li role="tab" class="done" *ngIf="role == 'Student'">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon feather icon-list"></i></span>
                                              Select Package
                                          </a>
                                      </li> -->
                                      <li role="tab" class="current">
                                          <a href="javascript:void(0)">
                                              <span class="step"><i class="step-icon  feather icon-cpu"></i></span>
                                              Confirmation
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                          <section class="my-3">
                              <div class="card">
                                  <div class="card-content">
                                      <div class="card-body">
                                          <fieldset class="my-3">
                                              <div class="row">
                                                  <div class="col-md-8 offset-2 text-center">
                                                      <i class="feather icon-info font-large-2"></i>
                                                      <h4 class="mt-2">Signup Successful</h4>
                                                      <h6 class="mb-3">You will receive a verification email, check and follow the steps</h6>
                                                      <hr>
                                                      <p>
                                                          Find the verification email we have sent you in your mail inbox. If you are unable
                                                          to find the mail in inbox, do check the 'spam' folder. The email will contain a
                                                          'Verify Account' button. Click on that button, it will take you to a new screen where
                                                           you can set password for your account.
                                                      </p>
                                                  </div>
                                              </div>
                                          </fieldset>
                                      </div>
                                  </div>
                              </div>
                          </section>
                      </div>
                  </div>
              </section>
          </div>
      </div>
  </div>

  <footer class="footer footer-static footer-light navbar-shadow">
      <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
          <span class="float-md-left d-block d-md-inline-block">
              Copyright &copy; 2021
              <a class="text-bold-800 grey darken-2" href="https://oxibit.com" target="_blank">Oxibit Technologies</a>
          </span>
          <span class="float-md-right d-none d-lg-block">
              <!-- Hand-crafted & Made with <i class="feather icon-heart pink"></i> -->
          </span>
      </p>
  </footer>
</body>
